console.group("inicializando o pack de imagens do app")



import '/var/www/apps/lum/app/frontend/images/authentication-1-3.svg';

import '/var/www/apps/lum/app/frontend/images/authentication-2-81.svg';

import '/var/www/apps/lum/app/frontend/images/authentication-2-85.svg';

import '/var/www/apps/lum/app/frontend/images/authentication-34.svg';

import '/var/www/apps/lum/app/frontend/images/brand/1.png';

import '/var/www/apps/lum/app/frontend/images/brand/app_logo_full.png';

import '/var/www/apps/lum/app/frontend/images/brand/app_logo_vert.png';

import '/var/www/apps/lum/app/frontend/images/brand/app_symbol.png';

import '/var/www/apps/lum/app/frontend/images/brand/app_text.png';

import '/var/www/apps/lum/app/frontend/images/brand/avatar1.png';

import '/var/www/apps/lum/app/frontend/images/brand/avatar2.png';

import '/var/www/apps/lum/app/frontend/images/brand/avatar3.png';

import '/var/www/apps/lum/app/frontend/images/brand/avatar4.png';

import '/var/www/apps/lum/app/frontend/images/brand/avatar5.png';

import '/var/www/apps/lum/app/frontend/images/brand/avatar6.png';

import '/var/www/apps/lum/app/frontend/images/brand/example1.png';

import '/var/www/apps/lum/app/frontend/images/brand/polemk_auth_logo.png';

import '/var/www/apps/lum/app/frontend/images/doc-icon.png';

import '/var/www/apps/lum/app/frontend/images/empty-1.png';

import '/var/www/apps/lum/app/frontend/images/main.jpg';

import '/var/www/apps/lum/app/frontend/images/main_background - Copia.jpg';

import '/var/www/apps/lum/app/frontend/images/main_background.jpg';

import '/var/www/apps/lum/app/frontend/images/main_hero.jpg';

import '/var/www/apps/lum/app/frontend/images/main_map_bkg.jpg';

import '/var/www/apps/lum/app/frontend/images/pdf-icon.png';

import '/var/www/apps/lum/app/frontend/images/xls-icon.png';


console.groupEnd();
